/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BillingCycleInvoiceType,
  ConfirmPasswordResetRequest,
  ConfirmPasswordResetResponse,
  ConfirmRequest,
  ContactUsRequest,
  CreateBillingCycleRequest,
  CreateBillingCycleResponse,
  CreateContractsRequest,
  CreateContractsResponse,
  CreateCustomerRequest,
  CreateCustomerResponse,
  CreateInvoiceRequest,
  CreateInvoiceResponse,
  CreateMeterRequest,
  CreateMeterResponse,
  CreatePlanRequest,
  CreatePlanResponse,
  CreateRevisionedLineItemRequest,
  CreateRevisionedLineItemResponse,
  DeleteContractResponse,
  DeleteLineItemResponse,
  DeletePlanResponse,
  DeleteReportResponse,
  DeleteRevisionedLineItemResponse,
  DisablePlanResponse,
  Environment,
  FilterSampleEventsRequest,
  FilterSampleEventsResponse,
  GenerateMeasurementsRequest,
  GenerateMeasurementsResponse,
  GetAccountResponse,
  GetAnonymousCustomersReportResponse,
  GetApprovalFlowInvoicesListResponseInner,
  GetArAgingReportResponse,
  GetBillingCycleInvoicesResponse,
  GetBillingCyclePageResponse,
  GetBillingCyclesResponse,
  GetCommitmentReportResponse,
  GetContractBillingScheduleReportResponse,
  GetContractPageDataResponse,
  GetContractProductsOverviewsResponse,
  GetContractResponse,
  GetContractsOverviewsResponse,
  GetContractsReportResponse,
  GetContractsResponse,
  GetCreditLedgerOverviewResponse,
  GetCustomerCommitmentUsageResponse,
  GetCustomerInvoicePageDataResponse,
  GetCustomerResponse,
  GetCustomerRevenueReportResponse,
  GetCustomersOverviewsResponse,
  GetCustomersResponse,
  GetDailyEventsDigestedResponse,
  GetDynamicInvoiceResponse,
  GetEventFieldsResponse,
  GetEventNamesResponse,
  GetHomePageDataResponse,
  GetIntegrationsSettingsResponse,
  GetInvoicePdfResponse,
  GetInvoiceResponse,
  GetInvoicesOverviewsResponse,
  GetInvoicesStatisticsResponse,
  GetLatestEventsResponse,
  GetLightInvoicesResponse,
  GetMeasurementsResponse,
  GetMeasurementsStatsResponse,
  GetMeterInstanceKeysResponse,
  GetMetersResponse,
  GetMonthlyClouserReportResponse,
  GetNetSuiteSubsidiariesResponse,
  GetNotificationAlertsResponseInner,
  GetPaymentOverviewsResponse,
  GetPlanOverviewResponse,
  GetPlanOverviewsResponse,
  GetPlanResponse,
  GetPotentialChildCustomersResponse,
  GetProductsPageDataResponse,
  GetProductsUsageReportResponse,
  GetReportsResponseInner,
  GetRevenueByCurrencyResponse,
  GetRevenueChartDataResponse,
  GetUnchargedUsageReportResponse,
  GetUsageByMeterResponse,
  GetUsersResponse,
  HomePageBillingCycleResponse,
  HubspotAuthConnectResponse,
  InviteUserRequest,
  LoginRequest,
  LoginResponse,
  MeterDeleteResponse,
  NetSuiteConnectRequest,
  NetSuiteExportSalesOrderRequest,
  NetSuiteGetCustomerResponse,
  NetSuiteGetCustomersResponse,
  NetSuiteGetProductsResponse,
  NetSuiteSyncInvoicesRequest,
  NetSuiteSyncInvoicesResponse,
  NetSuiteUpdateSalesOrderRequest,
  Provider,
  ReceivePaymentRequest,
  RefreshTokenResponse,
  RenewContractRequest,
  RenewContractResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  ReviseContractRequest,
  ReviseContractResponse,
  SalesforceConnectRequest,
  SalesforceImportCustomersResponseInner,
  SandboxUserResponse,
  ShareInvoicesRequest,
  SignupRawRequest,
  SignupRawResponse,
  SignupRequest,
  SignupResponse,
  SlackAuthConnectRedirectResponseSchema,
  SlackEventHandlerRequestSchema,
  SlackEventHandlerResponse,
  SlackGetUsersResponseSchema,
  SlackSendInvoiceApprovalMessageRequestSchema,
  SlackSendInvoiceApprovalMessageResponseSchema,
  SoftUpdatePlanRequest,
  SoftUpdatePlanResponse,
  StripeConnectRequest,
  StripeCreateInvoiceRequest,
  StripeCreateInvoiceResponseInner,
  StripeGetCustomersResponse,
  TerminateContractRequest,
  TerminateContractResponse,
  TriggerReportJobRequest,
  TriggerReportJobResponse,
  UpdateAccountRequest,
  UpdateAccountResponse,
  UpdateBillingCycleRequest,
  UpdateBillingCycleResponse,
  UpdateContractRequest,
  UpdateContractResponse,
  UpdateContractStatusRequest,
  UpdateContractStatusResponse,
  UpdateCustomerChildrenRequest,
  UpdateCustomerChildrenResponse,
  UpdateCustomerRequest,
  UpdateCustomerResponse,
  UpdateIntegrationConfigurationRequest,
  UpdateIntegrationConfigurationResponse,
  UpdateInvoiceAdditionalDetailsRequest,
  UpdateInvoiceAdditionalDetailsResponse,
  UpdateInvoicesBillingStatusesRequest,
  UpdateInvoicesBillingStatusesResponse,
  UpdateInvoicesReviewStatusesRequest,
  UpdateInvoicesReviewStatusesResponse,
  UpdateLineItemRequest,
  UpdateLineItemResponse,
  UpdateMeterRequest,
  UpdateMeterResponse,
  UpdateNotificationAlertStatusRequest,
  UpdateNotificationAlertStatusResponse,
  UpdatePlanRequest,
  UpdatePlanResponse,
  UpdateRevisionedLineItemRequest,
  UpdateRevisionedLineItemResponse,
  UploadMeasurementsResponse,
  ValidateMeasurementDataResponse,
} from '../models/index';
import {
    BillingCycleInvoiceTypeFromJSON,
    BillingCycleInvoiceTypeToJSON,
    ConfirmPasswordResetRequestFromJSON,
    ConfirmPasswordResetRequestToJSON,
    ConfirmPasswordResetResponseFromJSON,
    ConfirmPasswordResetResponseToJSON,
    ConfirmRequestFromJSON,
    ConfirmRequestToJSON,
    ContactUsRequestFromJSON,
    ContactUsRequestToJSON,
    CreateBillingCycleRequestFromJSON,
    CreateBillingCycleRequestToJSON,
    CreateBillingCycleResponseFromJSON,
    CreateBillingCycleResponseToJSON,
    CreateContractsRequestFromJSON,
    CreateContractsRequestToJSON,
    CreateContractsResponseFromJSON,
    CreateContractsResponseToJSON,
    CreateCustomerRequestFromJSON,
    CreateCustomerRequestToJSON,
    CreateCustomerResponseFromJSON,
    CreateCustomerResponseToJSON,
    CreateInvoiceRequestFromJSON,
    CreateInvoiceRequestToJSON,
    CreateInvoiceResponseFromJSON,
    CreateInvoiceResponseToJSON,
    CreateMeterRequestFromJSON,
    CreateMeterRequestToJSON,
    CreateMeterResponseFromJSON,
    CreateMeterResponseToJSON,
    CreatePlanRequestFromJSON,
    CreatePlanRequestToJSON,
    CreatePlanResponseFromJSON,
    CreatePlanResponseToJSON,
    CreateRevisionedLineItemRequestFromJSON,
    CreateRevisionedLineItemRequestToJSON,
    CreateRevisionedLineItemResponseFromJSON,
    CreateRevisionedLineItemResponseToJSON,
    DeleteContractResponseFromJSON,
    DeleteContractResponseToJSON,
    DeleteLineItemResponseFromJSON,
    DeleteLineItemResponseToJSON,
    DeletePlanResponseFromJSON,
    DeletePlanResponseToJSON,
    DeleteReportResponseFromJSON,
    DeleteReportResponseToJSON,
    DeleteRevisionedLineItemResponseFromJSON,
    DeleteRevisionedLineItemResponseToJSON,
    DisablePlanResponseFromJSON,
    DisablePlanResponseToJSON,
    EnvironmentFromJSON,
    EnvironmentToJSON,
    FilterSampleEventsRequestFromJSON,
    FilterSampleEventsRequestToJSON,
    FilterSampleEventsResponseFromJSON,
    FilterSampleEventsResponseToJSON,
    GenerateMeasurementsRequestFromJSON,
    GenerateMeasurementsRequestToJSON,
    GenerateMeasurementsResponseFromJSON,
    GenerateMeasurementsResponseToJSON,
    GetAccountResponseFromJSON,
    GetAccountResponseToJSON,
    GetAnonymousCustomersReportResponseFromJSON,
    GetAnonymousCustomersReportResponseToJSON,
    GetApprovalFlowInvoicesListResponseInnerFromJSON,
    GetApprovalFlowInvoicesListResponseInnerToJSON,
    GetArAgingReportResponseFromJSON,
    GetArAgingReportResponseToJSON,
    GetBillingCycleInvoicesResponseFromJSON,
    GetBillingCycleInvoicesResponseToJSON,
    GetBillingCyclePageResponseFromJSON,
    GetBillingCyclePageResponseToJSON,
    GetBillingCyclesResponseFromJSON,
    GetBillingCyclesResponseToJSON,
    GetCommitmentReportResponseFromJSON,
    GetCommitmentReportResponseToJSON,
    GetContractBillingScheduleReportResponseFromJSON,
    GetContractBillingScheduleReportResponseToJSON,
    GetContractPageDataResponseFromJSON,
    GetContractPageDataResponseToJSON,
    GetContractProductsOverviewsResponseFromJSON,
    GetContractProductsOverviewsResponseToJSON,
    GetContractResponseFromJSON,
    GetContractResponseToJSON,
    GetContractsOverviewsResponseFromJSON,
    GetContractsOverviewsResponseToJSON,
    GetContractsReportResponseFromJSON,
    GetContractsReportResponseToJSON,
    GetContractsResponseFromJSON,
    GetContractsResponseToJSON,
    GetCreditLedgerOverviewResponseFromJSON,
    GetCreditLedgerOverviewResponseToJSON,
    GetCustomerCommitmentUsageResponseFromJSON,
    GetCustomerCommitmentUsageResponseToJSON,
    GetCustomerInvoicePageDataResponseFromJSON,
    GetCustomerInvoicePageDataResponseToJSON,
    GetCustomerResponseFromJSON,
    GetCustomerResponseToJSON,
    GetCustomerRevenueReportResponseFromJSON,
    GetCustomerRevenueReportResponseToJSON,
    GetCustomersOverviewsResponseFromJSON,
    GetCustomersOverviewsResponseToJSON,
    GetCustomersResponseFromJSON,
    GetCustomersResponseToJSON,
    GetDailyEventsDigestedResponseFromJSON,
    GetDailyEventsDigestedResponseToJSON,
    GetDynamicInvoiceResponseFromJSON,
    GetDynamicInvoiceResponseToJSON,
    GetEventFieldsResponseFromJSON,
    GetEventFieldsResponseToJSON,
    GetEventNamesResponseFromJSON,
    GetEventNamesResponseToJSON,
    GetHomePageDataResponseFromJSON,
    GetHomePageDataResponseToJSON,
    GetIntegrationsSettingsResponseFromJSON,
    GetIntegrationsSettingsResponseToJSON,
    GetInvoicePdfResponseFromJSON,
    GetInvoicePdfResponseToJSON,
    GetInvoiceResponseFromJSON,
    GetInvoiceResponseToJSON,
    GetInvoicesOverviewsResponseFromJSON,
    GetInvoicesOverviewsResponseToJSON,
    GetInvoicesStatisticsResponseFromJSON,
    GetInvoicesStatisticsResponseToJSON,
    GetLatestEventsResponseFromJSON,
    GetLatestEventsResponseToJSON,
    GetLightInvoicesResponseFromJSON,
    GetLightInvoicesResponseToJSON,
    GetMeasurementsResponseFromJSON,
    GetMeasurementsResponseToJSON,
    GetMeasurementsStatsResponseFromJSON,
    GetMeasurementsStatsResponseToJSON,
    GetMeterInstanceKeysResponseFromJSON,
    GetMeterInstanceKeysResponseToJSON,
    GetMetersResponseFromJSON,
    GetMetersResponseToJSON,
    GetMonthlyClouserReportResponseFromJSON,
    GetMonthlyClouserReportResponseToJSON,
    GetNetSuiteSubsidiariesResponseFromJSON,
    GetNetSuiteSubsidiariesResponseToJSON,
    GetNotificationAlertsResponseInnerFromJSON,
    GetNotificationAlertsResponseInnerToJSON,
    GetPaymentOverviewsResponseFromJSON,
    GetPaymentOverviewsResponseToJSON,
    GetPlanOverviewResponseFromJSON,
    GetPlanOverviewResponseToJSON,
    GetPlanOverviewsResponseFromJSON,
    GetPlanOverviewsResponseToJSON,
    GetPlanResponseFromJSON,
    GetPlanResponseToJSON,
    GetPotentialChildCustomersResponseFromJSON,
    GetPotentialChildCustomersResponseToJSON,
    GetProductsPageDataResponseFromJSON,
    GetProductsPageDataResponseToJSON,
    GetProductsUsageReportResponseFromJSON,
    GetProductsUsageReportResponseToJSON,
    GetReportsResponseInnerFromJSON,
    GetReportsResponseInnerToJSON,
    GetRevenueByCurrencyResponseFromJSON,
    GetRevenueByCurrencyResponseToJSON,
    GetRevenueChartDataResponseFromJSON,
    GetRevenueChartDataResponseToJSON,
    GetUnchargedUsageReportResponseFromJSON,
    GetUnchargedUsageReportResponseToJSON,
    GetUsageByMeterResponseFromJSON,
    GetUsageByMeterResponseToJSON,
    GetUsersResponseFromJSON,
    GetUsersResponseToJSON,
    HomePageBillingCycleResponseFromJSON,
    HomePageBillingCycleResponseToJSON,
    HubspotAuthConnectResponseFromJSON,
    HubspotAuthConnectResponseToJSON,
    InviteUserRequestFromJSON,
    InviteUserRequestToJSON,
    LoginRequestFromJSON,
    LoginRequestToJSON,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    MeterDeleteResponseFromJSON,
    MeterDeleteResponseToJSON,
    NetSuiteConnectRequestFromJSON,
    NetSuiteConnectRequestToJSON,
    NetSuiteExportSalesOrderRequestFromJSON,
    NetSuiteExportSalesOrderRequestToJSON,
    NetSuiteGetCustomerResponseFromJSON,
    NetSuiteGetCustomerResponseToJSON,
    NetSuiteGetCustomersResponseFromJSON,
    NetSuiteGetCustomersResponseToJSON,
    NetSuiteGetProductsResponseFromJSON,
    NetSuiteGetProductsResponseToJSON,
    NetSuiteSyncInvoicesRequestFromJSON,
    NetSuiteSyncInvoicesRequestToJSON,
    NetSuiteSyncInvoicesResponseFromJSON,
    NetSuiteSyncInvoicesResponseToJSON,
    NetSuiteUpdateSalesOrderRequestFromJSON,
    NetSuiteUpdateSalesOrderRequestToJSON,
    ProviderFromJSON,
    ProviderToJSON,
    ReceivePaymentRequestFromJSON,
    ReceivePaymentRequestToJSON,
    RefreshTokenResponseFromJSON,
    RefreshTokenResponseToJSON,
    RenewContractRequestFromJSON,
    RenewContractRequestToJSON,
    RenewContractResponseFromJSON,
    RenewContractResponseToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    ResetPasswordResponseFromJSON,
    ResetPasswordResponseToJSON,
    ReviseContractRequestFromJSON,
    ReviseContractRequestToJSON,
    ReviseContractResponseFromJSON,
    ReviseContractResponseToJSON,
    SalesforceConnectRequestFromJSON,
    SalesforceConnectRequestToJSON,
    SalesforceImportCustomersResponseInnerFromJSON,
    SalesforceImportCustomersResponseInnerToJSON,
    SandboxUserResponseFromJSON,
    SandboxUserResponseToJSON,
    ShareInvoicesRequestFromJSON,
    ShareInvoicesRequestToJSON,
    SignupRawRequestFromJSON,
    SignupRawRequestToJSON,
    SignupRawResponseFromJSON,
    SignupRawResponseToJSON,
    SignupRequestFromJSON,
    SignupRequestToJSON,
    SignupResponseFromJSON,
    SignupResponseToJSON,
    SlackAuthConnectRedirectResponseSchemaFromJSON,
    SlackAuthConnectRedirectResponseSchemaToJSON,
    SlackEventHandlerRequestSchemaFromJSON,
    SlackEventHandlerRequestSchemaToJSON,
    SlackEventHandlerResponseFromJSON,
    SlackEventHandlerResponseToJSON,
    SlackGetUsersResponseSchemaFromJSON,
    SlackGetUsersResponseSchemaToJSON,
    SlackSendInvoiceApprovalMessageRequestSchemaFromJSON,
    SlackSendInvoiceApprovalMessageRequestSchemaToJSON,
    SlackSendInvoiceApprovalMessageResponseSchemaFromJSON,
    SlackSendInvoiceApprovalMessageResponseSchemaToJSON,
    SoftUpdatePlanRequestFromJSON,
    SoftUpdatePlanRequestToJSON,
    SoftUpdatePlanResponseFromJSON,
    SoftUpdatePlanResponseToJSON,
    StripeConnectRequestFromJSON,
    StripeConnectRequestToJSON,
    StripeCreateInvoiceRequestFromJSON,
    StripeCreateInvoiceRequestToJSON,
    StripeCreateInvoiceResponseInnerFromJSON,
    StripeCreateInvoiceResponseInnerToJSON,
    StripeGetCustomersResponseFromJSON,
    StripeGetCustomersResponseToJSON,
    TerminateContractRequestFromJSON,
    TerminateContractRequestToJSON,
    TerminateContractResponseFromJSON,
    TerminateContractResponseToJSON,
    TriggerReportJobRequestFromJSON,
    TriggerReportJobRequestToJSON,
    TriggerReportJobResponseFromJSON,
    TriggerReportJobResponseToJSON,
    UpdateAccountRequestFromJSON,
    UpdateAccountRequestToJSON,
    UpdateAccountResponseFromJSON,
    UpdateAccountResponseToJSON,
    UpdateBillingCycleRequestFromJSON,
    UpdateBillingCycleRequestToJSON,
    UpdateBillingCycleResponseFromJSON,
    UpdateBillingCycleResponseToJSON,
    UpdateContractRequestFromJSON,
    UpdateContractRequestToJSON,
    UpdateContractResponseFromJSON,
    UpdateContractResponseToJSON,
    UpdateContractStatusRequestFromJSON,
    UpdateContractStatusRequestToJSON,
    UpdateContractStatusResponseFromJSON,
    UpdateContractStatusResponseToJSON,
    UpdateCustomerChildrenRequestFromJSON,
    UpdateCustomerChildrenRequestToJSON,
    UpdateCustomerChildrenResponseFromJSON,
    UpdateCustomerChildrenResponseToJSON,
    UpdateCustomerRequestFromJSON,
    UpdateCustomerRequestToJSON,
    UpdateCustomerResponseFromJSON,
    UpdateCustomerResponseToJSON,
    UpdateIntegrationConfigurationRequestFromJSON,
    UpdateIntegrationConfigurationRequestToJSON,
    UpdateIntegrationConfigurationResponseFromJSON,
    UpdateIntegrationConfigurationResponseToJSON,
    UpdateInvoiceAdditionalDetailsRequestFromJSON,
    UpdateInvoiceAdditionalDetailsRequestToJSON,
    UpdateInvoiceAdditionalDetailsResponseFromJSON,
    UpdateInvoiceAdditionalDetailsResponseToJSON,
    UpdateInvoicesBillingStatusesRequestFromJSON,
    UpdateInvoicesBillingStatusesRequestToJSON,
    UpdateInvoicesBillingStatusesResponseFromJSON,
    UpdateInvoicesBillingStatusesResponseToJSON,
    UpdateInvoicesReviewStatusesRequestFromJSON,
    UpdateInvoicesReviewStatusesRequestToJSON,
    UpdateInvoicesReviewStatusesResponseFromJSON,
    UpdateInvoicesReviewStatusesResponseToJSON,
    UpdateLineItemRequestFromJSON,
    UpdateLineItemRequestToJSON,
    UpdateLineItemResponseFromJSON,
    UpdateLineItemResponseToJSON,
    UpdateMeterRequestFromJSON,
    UpdateMeterRequestToJSON,
    UpdateMeterResponseFromJSON,
    UpdateMeterResponseToJSON,
    UpdateNotificationAlertStatusRequestFromJSON,
    UpdateNotificationAlertStatusRequestToJSON,
    UpdateNotificationAlertStatusResponseFromJSON,
    UpdateNotificationAlertStatusResponseToJSON,
    UpdatePlanRequestFromJSON,
    UpdatePlanRequestToJSON,
    UpdatePlanResponseFromJSON,
    UpdatePlanResponseToJSON,
    UpdateRevisionedLineItemRequestFromJSON,
    UpdateRevisionedLineItemRequestToJSON,
    UpdateRevisionedLineItemResponseFromJSON,
    UpdateRevisionedLineItemResponseToJSON,
    UploadMeasurementsResponseFromJSON,
    UploadMeasurementsResponseToJSON,
    ValidateMeasurementDataResponseFromJSON,
    ValidateMeasurementDataResponseToJSON,
} from '../models/index';

export interface ConfirmPasswordResetOperationRequest {
    confirmPasswordResetRequest: ConfirmPasswordResetRequest;
}

export interface ConfirmUserRequest {
    confirmRequest: ConfirmRequest;
}

export interface ContactUsOperationRequest {
    contactUsRequest: ContactUsRequest;
}

export interface CreateBillingCycleOperationRequest {
    createBillingCycleRequest: CreateBillingCycleRequest;
}

export interface CreateContractsOperationRequest {
    createContractsRequest: CreateContractsRequest;
}

export interface CreateCustomerOperationRequest {
    createCustomerRequest: CreateCustomerRequest;
}

export interface CreateInvoiceOperationRequest {
    createInvoiceRequest: CreateInvoiceRequest;
}

export interface CreateMeterOperationRequest {
    createMeterRequest: CreateMeterRequest;
}

export interface CreatePlanOperationRequest {
    createPlanRequest: CreatePlanRequest;
}

export interface CreateRevisionedLineItemOperationRequest {
    createRevisionedLineItemRequest: CreateRevisionedLineItemRequest;
}

export interface DeleteContractRequest {
    contractId: string;
}

export interface DeleteLineItemRequest {
    lineItemId: string;
}

export interface DeleteMeterRequest {
    meterId: string;
}

export interface DeletePlanRequest {
    planId: string;
}

export interface DeleteReportRequest {
    reportId: string;
}

export interface DeleteRevisionedLineItemRequest {
    revisionedLineItemId: string;
}

export interface DisablePlanRequest {
    planId: string;
}

export interface EventHandlerRequest {
    slackEventHandlerRequestSchema: SlackEventHandlerRequestSchema;
}

export interface ExportNetSuiteSalesOrderRequest {
    netSuiteExportSalesOrderRequest: NetSuiteExportSalesOrderRequest;
}

export interface FilterSampleEventsOperationRequest {
    filterSampleEventsRequest: FilterSampleEventsRequest;
}

export interface GenerateMeasurementsOperationRequest {
    generateMeasurementsRequest: GenerateMeasurementsRequest;
}

export interface GetAnonymousCustomersReportRequest {
    reportId?: string;
}

export interface GetApprovalFlowInvoicesListRequest {
    invoiceTypes: string;
}

export interface GetBillingCycleInvoicesRequest {
    page?: number | null;
    pageSize?: number | null;
    billingCycleInvoiceType?: BillingCycleInvoiceType;
    search?: string;
}

export interface GetBillingCycleOverviewsRequest {
    page?: number | null;
    pageSize?: number | null;
}

export interface GetBillingCyclePageRequest {
    search?: string;
}

export interface GetCommitmentReportRequest {
    reportId?: string;
}

export interface GetContractRequest {
    contractId: string;
}

export interface GetContractBillingScheduleReportRequest {
    contractId: string;
}

export interface GetContractPageDataRequest {
    contractId: string;
}

export interface GetContractProductsOverviewsRequest {
    contractId: string;
}

export interface GetContractsRequest {
    page?: number | null;
    pageSize?: number | null;
    search?: string;
    customerId?: string;
    contractStatuses?: string;
    syncStatuses?: string;
}

export interface GetContractsOverviewsRequest {
    page?: number | null;
    pageSize?: number | null;
    search?: string;
    contractStatuses?: string;
}

export interface GetContractsReportRequest {
    reportId?: string;
}

export interface GetCreditLedgerOverviewRequest {
    customerId: string;
}

export interface GetCustomerRequest {
    customerId: string;
}

export interface GetCustomerInvoicePageDataRequest {
    invoiceId: string;
    customerId: string;
}

export interface GetCustomerRevenueReportRequest {
    reportId?: string;
}

export interface GetCustomersRequest {
    page?: number | null;
    pageSize?: number | null;
}

export interface GetCustomersOverviewsRequest {
    page?: number | null;
    pageSize?: number | null;
    search?: string;
}

export interface GetDynamicInvoiceRequest {
    invoiceId: string;
}

export interface GetDynamicInvoiceByCustomerRequest {
    customerId: string;
}

export interface GetEventFieldsRequest {
    eventName: string;
}

export interface GetHomePageDataRequest {
    topGrossingCustomersSize?: number;
    topGrossingPlansSize?: number;
}

export interface GetIntegrationsSettingsRequest {
    provider: Provider;
}

export interface GetInvoiceRequest {
    invoiceId: string;
}

export interface GetInvoicePdfRequest {
    invoiceId: string;
}

export interface GetInvoicesOverviewsRequest {
    page?: number | null;
    pageSize?: number | null;
    search?: string;
    customerId?: string;
    dates?: string;
    reviewStatuses?: string;
    billingStatuses?: string;
    additionalFilters?: string;
}

export interface GetInvoicesStatisticsRequest {
    customerId?: string;
}

export interface GetLatestEventsRequest {
    page?: number | null;
    pageSize?: number | null;
    endTime?: Date;
    startTime?: Date;
    metersIds?: string;
    customersIds?: string;
}

export interface GetLightInvoicesRequest {
    invoicesIds: string;
}

export interface GetMeasurementsRequest {
    startTime: Date;
    endTime: Date;
    customersIds?: string;
    metersIds?: string;
}

export interface GetMeasurementsStatsRequest {
    startTime: Date;
    endTime: Date;
    customersIds?: string;
    metersIds?: string;
    eventNames?: string;
}

export interface GetMeterInstanceKeysRequest {
    customerId: string;
    productId: string;
}

export interface GetMonthlyClouserReportRequest {
    reportId?: string;
}

export interface GetNetSuiteSubsidiariesRequest {
    erpId: string;
}

export interface GetPaymentOverviewsRequest {
    startTime: Date;
    endTime: Date;
    page?: number | null;
    pageSize?: number | null;
    search?: string;
}

export interface GetPlanRequest {
    planId: string;
}

export interface GetPlanOverviewRequest {
    planId: string;
}

export interface GetPlanOverviewsRequest {
    page?: number | null;
    pageSize?: number | null;
    search?: string;
    planStatuses?: string;
}

export interface GetProductsPageDataRequest {
    search?: string;
    page?: number | null;
    pageSize?: number | null;
}

export interface GetProductsUsageReportRequest {
    reportId?: string;
}

export interface GetSandboxUserRequest {
    environment: Environment;
}

export interface GetUnchargedUsageReportRequest {
    reportId?: string;
}

export interface HubspotAuthCallbackRequest {
    code: string;
    state: string;
}

export interface InviteUserOperationRequest {
    inviteUserRequest: InviteUserRequest;
}

export interface LoginOperationRequest {
    loginRequest: LoginRequest;
}

export interface NetSuiteConnectOperationRequest {
    netSuiteConnectRequest: NetSuiteConnectRequest;
}

export interface NetSuiteGetCustomerRequest {
    customerId: string;
}

export interface NetSuiteGetCustomersRequest {
    search?: string;
}

export interface NetSuiteSyncInvoicesOperationRequest {
    netSuiteSyncInvoicesRequest: NetSuiteSyncInvoicesRequest;
}

export interface NetSuiteUpdateSalesOrderOperationRequest {
    netSuiteUpdateSalesOrderRequest: NetSuiteUpdateSalesOrderRequest;
}

export interface RawSignupRequest {
    signupRawRequest: SignupRawRequest;
}

export interface ReceivePaymentOperationRequest {
    receivePaymentRequest: ReceivePaymentRequest;
}

export interface RenewContractOperationRequest {
    contractId: string;
    renewContractRequest: RenewContractRequest;
}

export interface ResetPasswordOperationRequest {
    resetPasswordRequest: ResetPasswordRequest;
}

export interface ReviseContractOperationRequest {
    contractId: string;
    reviseContractRequest: ReviseContractRequest;
}

export interface SalesforceConnectOperationRequest {
    salesforceConnectRequest: SalesforceConnectRequest;
}

export interface SendSlackInvoiceApprovalMessageRequest {
    slackSendInvoiceApprovalMessageRequestSchema: SlackSendInvoiceApprovalMessageRequestSchema;
}

export interface ShareInvoicesOperationRequest {
    shareInvoicesRequest: Array<ShareInvoicesRequest>;
}

export interface SignupOperationRequest {
    signupRequest: SignupRequest;
}

export interface SlackCallbackRequest {
    code: string;
    state: string;
}

export interface SlackConnectRequest {
    redirectUrl: string;
}

export interface SoftUpdatePlanOperationRequest {
    planId: string;
    softUpdatePlanRequest: SoftUpdatePlanRequest;
}

export interface StripeConnectOperationRequest {
    stripeConnectRequest: StripeConnectRequest;
}

export interface StripeCreateInvoiceOperationRequest {
    stripeCreateInvoiceRequest: StripeCreateInvoiceRequest;
}

export interface StripeEventRequest {
    stripeEventAccountId: string;
    body: any | null;
}

export interface TerminateContractOperationRequest {
    contractId: string;
    terminateContractRequest: TerminateContractRequest;
}

export interface TriggerReportJobOperationRequest {
    triggerReportJobRequest: TriggerReportJobRequest;
}

export interface UpdateAccountOperationRequest {
    updateAccountRequest: UpdateAccountRequest;
}

export interface UpdateBillingCycleOperationRequest {
    billingCycleId: string;
    updateBillingCycleRequest: UpdateBillingCycleRequest;
}

export interface UpdateContractOperationRequest {
    contractId: string;
    updateContractRequest: UpdateContractRequest;
}

export interface UpdateContractStatusOperationRequest {
    contractId: string;
    updateContractStatusRequest: UpdateContractStatusRequest;
}

export interface UpdateCustomerOperationRequest {
    customerId: string;
    updateCustomerRequest: UpdateCustomerRequest;
}

export interface UpdateCustomerChildrenOperationRequest {
    customerId: string;
    updateCustomerChildrenRequest: UpdateCustomerChildrenRequest;
}

export interface UpdateIntegrationConfigurationOperationRequest {
    updateIntegrationConfigurationRequest: UpdateIntegrationConfigurationRequest;
}

export interface UpdateInvoiceAdditionalDetailsOperationRequest {
    updateInvoiceAdditionalDetailsRequest: UpdateInvoiceAdditionalDetailsRequest;
}

export interface UpdateInvoicesBillingStatusesOperationRequest {
    updateInvoicesBillingStatusesRequest: UpdateInvoicesBillingStatusesRequest;
}

export interface UpdateInvoicesReviewStatusesOperationRequest {
    updateInvoicesReviewStatusesRequest: UpdateInvoicesReviewStatusesRequest;
}

export interface UpdateLineItemOperationRequest {
    lineItemId: string;
    updateLineItemRequest: UpdateLineItemRequest;
}

export interface UpdateMeterOperationRequest {
    meterId: string;
    updateMeterRequest: UpdateMeterRequest;
}

export interface UpdateNotificationAlertStatusOperationRequest {
    notificationAlertId: string;
    updateNotificationAlertStatusRequest: UpdateNotificationAlertStatusRequest;
}

export interface UpdatePlanOperationRequest {
    planId: string;
    updatePlanRequest: UpdatePlanRequest;
}

export interface UpdateRevisionedLineItemOperationRequest {
    revisionedLineItemId: string;
    updateRevisionedLineItemRequest: UpdateRevisionedLineItemRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async confirmPasswordResetRaw(requestParameters: ConfirmPasswordResetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfirmPasswordResetResponse>> {
        if (requestParameters.confirmPasswordResetRequest === null || requestParameters.confirmPasswordResetRequest === undefined) {
            throw new runtime.RequiredError('confirmPasswordResetRequest','Required parameter requestParameters.confirmPasswordResetRequest was null or undefined when calling confirmPasswordReset.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/confirm-password-reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmPasswordResetRequestToJSON(requestParameters.confirmPasswordResetRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfirmPasswordResetResponseFromJSON(jsonValue));
    }

    /**
     */
    async confirmPasswordReset(requestParameters: ConfirmPasswordResetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfirmPasswordResetResponse> {
        const response = await this.confirmPasswordResetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async confirmUserRaw(requestParameters: ConfirmUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.confirmRequest === null || requestParameters.confirmRequest === undefined) {
            throw new runtime.RequiredError('confirmRequest','Required parameter requestParameters.confirmRequest was null or undefined when calling confirmUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmRequestToJSON(requestParameters.confirmRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async confirmUser(requestParameters: ConfirmUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contactUsRaw(requestParameters: ContactUsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.contactUsRequest === null || requestParameters.contactUsRequest === undefined) {
            throw new runtime.RequiredError('contactUsRequest','Required parameter requestParameters.contactUsRequest was null or undefined when calling contactUs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/contact-us/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactUsRequestToJSON(requestParameters.contactUsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contactUs(requestParameters: ContactUsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contactUsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createBillingCycleRaw(requestParameters: CreateBillingCycleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingCycleResponse>> {
        if (requestParameters.createBillingCycleRequest === null || requestParameters.createBillingCycleRequest === undefined) {
            throw new runtime.RequiredError('createBillingCycleRequest','Required parameter requestParameters.createBillingCycleRequest was null or undefined when calling createBillingCycle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-cycles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBillingCycleRequestToJSON(requestParameters.createBillingCycleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBillingCycleResponseFromJSON(jsonValue));
    }

    /**
     */
    async createBillingCycle(requestParameters: CreateBillingCycleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingCycleResponse> {
        const response = await this.createBillingCycleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createContractsRaw(requestParameters: CreateContractsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateContractsResponse>> {
        if (requestParameters.createContractsRequest === null || requestParameters.createContractsRequest === undefined) {
            throw new runtime.RequiredError('createContractsRequest','Required parameter requestParameters.createContractsRequest was null or undefined when calling createContracts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contracts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContractsRequestToJSON(requestParameters.createContractsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateContractsResponseFromJSON(jsonValue));
    }

    /**
     */
    async createContracts(requestParameters: CreateContractsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateContractsResponse> {
        const response = await this.createContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCustomerRaw(requestParameters: CreateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCustomerResponse>> {
        if (requestParameters.createCustomerRequest === null || requestParameters.createCustomerRequest === undefined) {
            throw new runtime.RequiredError('createCustomerRequest','Required parameter requestParameters.createCustomerRequest was null or undefined when calling createCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCustomerRequestToJSON(requestParameters.createCustomerRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCustomerResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCustomer(requestParameters: CreateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCustomerResponse> {
        const response = await this.createCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createInvoiceRaw(requestParameters: CreateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateInvoiceResponse>> {
        if (requestParameters.createInvoiceRequest === null || requestParameters.createInvoiceRequest === undefined) {
            throw new runtime.RequiredError('createInvoiceRequest','Required parameter requestParameters.createInvoiceRequest was null or undefined when calling createInvoice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInvoiceRequestToJSON(requestParameters.createInvoiceRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateInvoiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async createInvoice(requestParameters: CreateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateInvoiceResponse> {
        const response = await this.createInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createMeterRaw(requestParameters: CreateMeterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMeterResponse>> {
        if (requestParameters.createMeterRequest === null || requestParameters.createMeterRequest === undefined) {
            throw new runtime.RequiredError('createMeterRequest','Required parameter requestParameters.createMeterRequest was null or undefined when calling createMeter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/meter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMeterRequestToJSON(requestParameters.createMeterRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMeterResponseFromJSON(jsonValue));
    }

    /**
     */
    async createMeter(requestParameters: CreateMeterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMeterResponse> {
        const response = await this.createMeterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPlanRaw(requestParameters: CreatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePlanResponse>> {
        if (requestParameters.createPlanRequest === null || requestParameters.createPlanRequest === undefined) {
            throw new runtime.RequiredError('createPlanRequest','Required parameter requestParameters.createPlanRequest was null or undefined when calling createPlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlanRequestToJSON(requestParameters.createPlanRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePlanResponseFromJSON(jsonValue));
    }

    /**
     */
    async createPlan(requestParameters: CreatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePlanResponse> {
        const response = await this.createPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createRevisionedLineItemRaw(requestParameters: CreateRevisionedLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateRevisionedLineItemResponse>> {
        if (requestParameters.createRevisionedLineItemRequest === null || requestParameters.createRevisionedLineItemRequest === undefined) {
            throw new runtime.RequiredError('createRevisionedLineItemRequest','Required parameter requestParameters.createRevisionedLineItemRequest was null or undefined when calling createRevisionedLineItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/revisioned-line-item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRevisionedLineItemRequestToJSON(requestParameters.createRevisionedLineItemRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateRevisionedLineItemResponseFromJSON(jsonValue));
    }

    /**
     */
    async createRevisionedLineItem(requestParameters: CreateRevisionedLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateRevisionedLineItemResponse> {
        const response = await this.createRevisionedLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteContractRaw(requestParameters: DeleteContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteContractResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling deleteContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteContractResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteContract(requestParameters: DeleteContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteContractResponse> {
        const response = await this.deleteContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteLineItemRaw(requestParameters: DeleteLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLineItemResponse>> {
        if (requestParameters.lineItemId === null || requestParameters.lineItemId === undefined) {
            throw new runtime.RequiredError('lineItemId','Required parameter requestParameters.lineItemId was null or undefined when calling deleteLineItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/line-item/{lineItemId}`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteLineItemResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteLineItem(requestParameters: DeleteLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLineItemResponse> {
        const response = await this.deleteLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteMeterRaw(requestParameters: DeleteMeterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeterDeleteResponse>> {
        if (requestParameters.meterId === null || requestParameters.meterId === undefined) {
            throw new runtime.RequiredError('meterId','Required parameter requestParameters.meterId was null or undefined when calling deleteMeter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/meter/{meterId}`.replace(`{${"meterId"}}`, encodeURIComponent(String(requestParameters.meterId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeterDeleteResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteMeter(requestParameters: DeleteMeterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeterDeleteResponse> {
        const response = await this.deleteMeterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deletePlanRaw(requestParameters: DeletePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletePlanResponse>> {
        if (requestParameters.planId === null || requestParameters.planId === undefined) {
            throw new runtime.RequiredError('planId','Required parameter requestParameters.planId was null or undefined when calling deletePlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletePlanResponseFromJSON(jsonValue));
    }

    /**
     */
    async deletePlan(requestParameters: DeletePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletePlanResponse> {
        const response = await this.deletePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteReportRaw(requestParameters: DeleteReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReportResponse>> {
        if (requestParameters.reportId === null || requestParameters.reportId === undefined) {
            throw new runtime.RequiredError('reportId','Required parameter requestParameters.reportId was null or undefined when calling deleteReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/{reportId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters.reportId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteReport(requestParameters: DeleteReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReportResponse> {
        const response = await this.deleteReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteRevisionedLineItemRaw(requestParameters: DeleteRevisionedLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteRevisionedLineItemResponse>> {
        if (requestParameters.revisionedLineItemId === null || requestParameters.revisionedLineItemId === undefined) {
            throw new runtime.RequiredError('revisionedLineItemId','Required parameter requestParameters.revisionedLineItemId was null or undefined when calling deleteRevisionedLineItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/revisioned-line-item/{revisionedLineItemId}`.replace(`{${"revisionedLineItemId"}}`, encodeURIComponent(String(requestParameters.revisionedLineItemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteRevisionedLineItemResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteRevisionedLineItem(requestParameters: DeleteRevisionedLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteRevisionedLineItemResponse> {
        const response = await this.deleteRevisionedLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async disablePlanRaw(requestParameters: DisablePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisablePlanResponse>> {
        if (requestParameters.planId === null || requestParameters.planId === undefined) {
            throw new runtime.RequiredError('planId','Required parameter requestParameters.planId was null or undefined when calling disablePlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan/disable/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisablePlanResponseFromJSON(jsonValue));
    }

    /**
     */
    async disablePlan(requestParameters: DisablePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisablePlanResponse> {
        const response = await this.disablePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async eventHandlerRaw(requestParameters: EventHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SlackEventHandlerResponse>> {
        if (requestParameters.slackEventHandlerRequestSchema === null || requestParameters.slackEventHandlerRequestSchema === undefined) {
            throw new runtime.RequiredError('slackEventHandlerRequestSchema','Required parameter requestParameters.slackEventHandlerRequestSchema was null or undefined when calling eventHandler.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/integrations/slack/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SlackEventHandlerRequestSchemaToJSON(requestParameters.slackEventHandlerRequestSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SlackEventHandlerResponseFromJSON(jsonValue));
    }

    /**
     */
    async eventHandler(requestParameters: EventHandlerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SlackEventHandlerResponse> {
        const response = await this.eventHandlerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportNetSuiteSalesOrderRaw(requestParameters: ExportNetSuiteSalesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.netSuiteExportSalesOrderRequest === null || requestParameters.netSuiteExportSalesOrderRequest === undefined) {
            throw new runtime.RequiredError('netSuiteExportSalesOrderRequest','Required parameter requestParameters.netSuiteExportSalesOrderRequest was null or undefined when calling exportNetSuiteSalesOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/export-sales-order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NetSuiteExportSalesOrderRequestToJSON(requestParameters.netSuiteExportSalesOrderRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exportNetSuiteSalesOrder(requestParameters: ExportNetSuiteSalesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exportNetSuiteSalesOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async filterSampleEventsRaw(requestParameters: FilterSampleEventsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FilterSampleEventsResponse>> {
        if (requestParameters.filterSampleEventsRequest === null || requestParameters.filterSampleEventsRequest === undefined) {
            throw new runtime.RequiredError('filterSampleEventsRequest','Required parameter requestParameters.filterSampleEventsRequest was null or undefined when calling filterSampleEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/events/sample`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterSampleEventsRequestToJSON(requestParameters.filterSampleEventsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FilterSampleEventsResponseFromJSON(jsonValue));
    }

    /**
     */
    async filterSampleEvents(requestParameters: FilterSampleEventsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FilterSampleEventsResponse> {
        const response = await this.filterSampleEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async generateMeasurementsRaw(requestParameters: GenerateMeasurementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateMeasurementsResponse>> {
        if (requestParameters.generateMeasurementsRequest === null || requestParameters.generateMeasurementsRequest === undefined) {
            throw new runtime.RequiredError('generateMeasurementsRequest','Required parameter requestParameters.generateMeasurementsRequest was null or undefined when calling generateMeasurements.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/measurements/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateMeasurementsRequestToJSON(requestParameters.generateMeasurementsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateMeasurementsResponseFromJSON(jsonValue));
    }

    /**
     */
    async generateMeasurements(requestParameters: GenerateMeasurementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateMeasurementsResponse> {
        const response = await this.generateMeasurementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountResponse> {
        const response = await this.getAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAnonymousCustomersReportRaw(requestParameters: GetAnonymousCustomersReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAnonymousCustomersReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/anonymous-customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAnonymousCustomersReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAnonymousCustomersReport(requestParameters: GetAnonymousCustomersReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAnonymousCustomersReportResponse> {
        const response = await this.getAnonymousCustomersReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getApprovalFlowInvoicesListRaw(requestParameters: GetApprovalFlowInvoicesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetApprovalFlowInvoicesListResponseInner>>> {
        if (requestParameters.invoiceTypes === null || requestParameters.invoiceTypes === undefined) {
            throw new runtime.RequiredError('invoiceTypes','Required parameter requestParameters.invoiceTypes was null or undefined when calling getApprovalFlowInvoicesList.');
        }

        const queryParameters: any = {};

        if (requestParameters.invoiceTypes !== undefined) {
            queryParameters['invoiceTypes'] = requestParameters.invoiceTypes;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/approval-flow`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetApprovalFlowInvoicesListResponseInnerFromJSON));
    }

    /**
     */
    async getApprovalFlowInvoicesList(requestParameters: GetApprovalFlowInvoicesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetApprovalFlowInvoicesListResponseInner>> {
        const response = await this.getApprovalFlowInvoicesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getArAgingReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetArAgingReportResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/ar-aging`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetArAgingReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getArAgingReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetArAgingReportResponse> {
        const response = await this.getArAgingReportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBillingCycleInvoicesRaw(requestParameters: GetBillingCycleInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingCycleInvoicesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.billingCycleInvoiceType !== undefined) {
            queryParameters['billingCycleInvoiceType'] = requestParameters.billingCycleInvoiceType;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/billing-cycle`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingCycleInvoicesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBillingCycleInvoices(requestParameters: GetBillingCycleInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingCycleInvoicesResponse> {
        const response = await this.getBillingCycleInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBillingCycleOverviewsRaw(requestParameters: GetBillingCycleOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingCyclesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-cycles/overviews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingCyclesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBillingCycleOverviews(requestParameters: GetBillingCycleOverviewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingCyclesResponse> {
        const response = await this.getBillingCycleOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBillingCyclePageRaw(requestParameters: GetBillingCyclePageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingCyclePageResponse>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pages/billing-cycle`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingCyclePageResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBillingCyclePage(requestParameters: GetBillingCyclePageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingCyclePageResponse> {
        const response = await this.getBillingCyclePageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCommitmentReportRaw(requestParameters: GetCommitmentReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCommitmentReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/commitment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCommitmentReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCommitmentReport(requestParameters: GetCommitmentReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCommitmentReportResponse> {
        const response = await this.getCommitmentReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getConnectedIntegrationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/connected`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getConnectedIntegrations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getConnectedIntegrationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractRaw(requestParameters: GetContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContract(requestParameters: GetContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractResponse> {
        const response = await this.getContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractBillingScheduleReportRaw(requestParameters: GetContractBillingScheduleReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractBillingScheduleReportResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContractBillingScheduleReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/contract-billing-schedule/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractBillingScheduleReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContractBillingScheduleReport(requestParameters: GetContractBillingScheduleReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractBillingScheduleReportResponse> {
        const response = await this.getContractBillingScheduleReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractPageDataRaw(requestParameters: GetContractPageDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractPageDataResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContractPageData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pages/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractPageDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContractPageData(requestParameters: GetContractPageDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractPageDataResponse> {
        const response = await this.getContractPageDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractProductsOverviewsRaw(requestParameters: GetContractProductsOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractProductsOverviewsResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContractProductsOverviews.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/products-overviews/{contractId}/`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractProductsOverviewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContractProductsOverviews(requestParameters: GetContractProductsOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractProductsOverviewsResponse> {
        const response = await this.getContractProductsOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractsRaw(requestParameters: GetContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        if (requestParameters.contractStatuses !== undefined) {
            queryParameters['contractStatuses'] = requestParameters.contractStatuses;
        }

        if (requestParameters.syncStatuses !== undefined) {
            queryParameters['syncStatuses'] = requestParameters.syncStatuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contracts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContracts(requestParameters: GetContractsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractsResponse> {
        const response = await this.getContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractsOverviewsRaw(requestParameters: GetContractsOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractsOverviewsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.contractStatuses !== undefined) {
            queryParameters['contractStatuses'] = requestParameters.contractStatuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contracts/overviews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractsOverviewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContractsOverviews(requestParameters: GetContractsOverviewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractsOverviewsResponse> {
        const response = await this.getContractsOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractsReportRaw(requestParameters: GetContractsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractsReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/contracts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractsReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContractsReport(requestParameters: GetContractsReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractsReportResponse> {
        const response = await this.getContractsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCreditLedgerOverviewRaw(requestParameters: GetCreditLedgerOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCreditLedgerOverviewResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCreditLedgerOverview.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credit-ledger/overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCreditLedgerOverviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCreditLedgerOverview(requestParameters: GetCreditLedgerOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCreditLedgerOverviewResponse> {
        const response = await this.getCreditLedgerOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerResponse> {
        const response = await this.getCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerCommitmentUsageRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerCommitmentUsageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/data-dashboard/customer-commitment-usage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerCommitmentUsageResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerCommitmentUsage(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerCommitmentUsageResponse> {
        const response = await this.getCustomerCommitmentUsageRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerInvoicePageDataRaw(requestParameters: GetCustomerInvoicePageDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerInvoicePageDataResponse>> {
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId','Required parameter requestParameters.invoiceId was null or undefined when calling getCustomerInvoicePageData.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomerInvoicePageData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pages/customers/{customerId}/invoice/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerInvoicePageDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerInvoicePageData(requestParameters: GetCustomerInvoicePageDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerInvoicePageDataResponse> {
        const response = await this.getCustomerInvoicePageDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerRevenueReportRaw(requestParameters: GetCustomerRevenueReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerRevenueReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/customer-revenue`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerRevenueReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerRevenueReport(requestParameters: GetCustomerRevenueReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerRevenueReportResponse> {
        const response = await this.getCustomerRevenueReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomersRaw(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomersResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomers(requestParameters: GetCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomersResponse> {
        const response = await this.getCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomersOverviewsRaw(requestParameters: GetCustomersOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomersOverviewsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/overviews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomersOverviewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomersOverviews(requestParameters: GetCustomersOverviewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomersOverviewsResponse> {
        const response = await this.getCustomersOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDailyEventsDigestedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDailyEventsDigestedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/data-dashboard/daily-events-digested`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDailyEventsDigestedResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDailyEventsDigested(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDailyEventsDigestedResponse> {
        const response = await this.getDailyEventsDigestedRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDynamicInvoiceRaw(requestParameters: GetDynamicInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDynamicInvoiceResponse>> {
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId','Required parameter requestParameters.invoiceId was null or undefined when calling getDynamicInvoice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoice/dynamic/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDynamicInvoiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDynamicInvoice(requestParameters: GetDynamicInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDynamicInvoiceResponse> {
        const response = await this.getDynamicInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDynamicInvoiceByCustomerRaw(requestParameters: GetDynamicInvoiceByCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDynamicInvoiceResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getDynamicInvoiceByCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoice/dynamic/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDynamicInvoiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDynamicInvoiceByCustomer(requestParameters: GetDynamicInvoiceByCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDynamicInvoiceResponse> {
        const response = await this.getDynamicInvoiceByCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEventFieldsRaw(requestParameters: GetEventFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEventFieldsResponse>> {
        if (requestParameters.eventName === null || requestParameters.eventName === undefined) {
            throw new runtime.RequiredError('eventName','Required parameter requestParameters.eventName was null or undefined when calling getEventFields.');
        }

        const queryParameters: any = {};

        if (requestParameters.eventName !== undefined) {
            queryParameters['eventName'] = requestParameters.eventName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/event-fields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEventFieldsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEventFields(requestParameters: GetEventFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEventFieldsResponse> {
        const response = await this.getEventFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEventNamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEventNamesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/event-fields/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEventNamesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEventNames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEventNamesResponse> {
        const response = await this.getEventNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getHomePageDataRaw(requestParameters: GetHomePageDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHomePageDataResponse>> {
        const queryParameters: any = {};

        if (requestParameters.topGrossingCustomersSize !== undefined) {
            queryParameters['topGrossingCustomersSize'] = requestParameters.topGrossingCustomersSize;
        }

        if (requestParameters.topGrossingPlansSize !== undefined) {
            queryParameters['topGrossingPlansSize'] = requestParameters.topGrossingPlansSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pages/home`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHomePageDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getHomePageData(requestParameters: GetHomePageDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHomePageDataResponse> {
        const response = await this.getHomePageDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getHomepageBillingCycleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomePageBillingCycleResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-cycles/homepage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomePageBillingCycleResponseFromJSON(jsonValue));
    }

    /**
     */
    async getHomepageBillingCycle(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomePageBillingCycleResponse> {
        const response = await this.getHomepageBillingCycleRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getIntegrationsSettingsRaw(requestParameters: GetIntegrationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIntegrationsSettingsResponse>> {
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider','Required parameter requestParameters.provider was null or undefined when calling getIntegrationsSettings.');
        }

        const queryParameters: any = {};

        if (requestParameters.provider !== undefined) {
            queryParameters['provider'] = requestParameters.provider;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIntegrationsSettingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getIntegrationsSettings(requestParameters: GetIntegrationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIntegrationsSettingsResponse> {
        const response = await this.getIntegrationsSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInvoiceRaw(requestParameters: GetInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoiceResponse>> {
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId','Required parameter requestParameters.invoiceId was null or undefined when calling getInvoice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoice/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInvoice(requestParameters: GetInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoiceResponse> {
        const response = await this.getInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInvoicePdfRaw(requestParameters: GetInvoicePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicePdfResponse>> {
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId','Required parameter requestParameters.invoiceId was null or undefined when calling getInvoicePdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoice/pdf/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicePdfResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInvoicePdf(requestParameters: GetInvoicePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicePdfResponse> {
        const response = await this.getInvoicePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInvoicesOverviewsRaw(requestParameters: GetInvoicesOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicesOverviewsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        if (requestParameters.dates !== undefined) {
            queryParameters['dates'] = requestParameters.dates;
        }

        if (requestParameters.reviewStatuses !== undefined) {
            queryParameters['reviewStatuses'] = requestParameters.reviewStatuses;
        }

        if (requestParameters.billingStatuses !== undefined) {
            queryParameters['billingStatuses'] = requestParameters.billingStatuses;
        }

        if (requestParameters.additionalFilters !== undefined) {
            queryParameters['additionalFilters'] = requestParameters.additionalFilters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/overviews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicesOverviewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInvoicesOverviews(requestParameters: GetInvoicesOverviewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicesOverviewsResponse> {
        const response = await this.getInvoicesOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInvoicesStatisticsRaw(requestParameters: GetInvoicesStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicesStatisticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicesStatisticsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInvoicesStatistics(requestParameters: GetInvoicesStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicesStatisticsResponse> {
        const response = await this.getInvoicesStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLatestEventsRaw(requestParameters: GetLatestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestEventsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.metersIds !== undefined) {
            queryParameters['metersIds'] = requestParameters.metersIds;
        }

        if (requestParameters.customersIds !== undefined) {
            queryParameters['customersIds'] = requestParameters.customersIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/events/latest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestEventsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLatestEvents(requestParameters: GetLatestEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestEventsResponse> {
        const response = await this.getLatestEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLightInvoicesRaw(requestParameters: GetLightInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLightInvoicesResponse>> {
        if (requestParameters.invoicesIds === null || requestParameters.invoicesIds === undefined) {
            throw new runtime.RequiredError('invoicesIds','Required parameter requestParameters.invoicesIds was null or undefined when calling getLightInvoices.');
        }

        const queryParameters: any = {};

        if (requestParameters.invoicesIds !== undefined) {
            queryParameters['invoicesIds'] = requestParameters.invoicesIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/light`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLightInvoicesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLightInvoices(requestParameters: GetLightInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLightInvoicesResponse> {
        const response = await this.getLightInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMeasurementsRaw(requestParameters: GetMeasurementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeasurementsResponse>> {
        if (requestParameters.startTime === null || requestParameters.startTime === undefined) {
            throw new runtime.RequiredError('startTime','Required parameter requestParameters.startTime was null or undefined when calling getMeasurements.');
        }

        if (requestParameters.endTime === null || requestParameters.endTime === undefined) {
            throw new runtime.RequiredError('endTime','Required parameter requestParameters.endTime was null or undefined when calling getMeasurements.');
        }

        const queryParameters: any = {};

        if (requestParameters.customersIds !== undefined) {
            queryParameters['customersIds'] = requestParameters.customersIds;
        }

        if (requestParameters.metersIds !== undefined) {
            queryParameters['metersIds'] = requestParameters.metersIds;
        }

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/measurements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeasurementsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMeasurements(requestParameters: GetMeasurementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeasurementsResponse> {
        const response = await this.getMeasurementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMeasurementsStatsRaw(requestParameters: GetMeasurementsStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeasurementsStatsResponse>> {
        if (requestParameters.startTime === null || requestParameters.startTime === undefined) {
            throw new runtime.RequiredError('startTime','Required parameter requestParameters.startTime was null or undefined when calling getMeasurementsStats.');
        }

        if (requestParameters.endTime === null || requestParameters.endTime === undefined) {
            throw new runtime.RequiredError('endTime','Required parameter requestParameters.endTime was null or undefined when calling getMeasurementsStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.customersIds !== undefined) {
            queryParameters['customersIds'] = requestParameters.customersIds;
        }

        if (requestParameters.metersIds !== undefined) {
            queryParameters['metersIds'] = requestParameters.metersIds;
        }

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        if (requestParameters.eventNames !== undefined) {
            queryParameters['eventNames'] = requestParameters.eventNames;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/measurements/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeasurementsStatsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMeasurementsStats(requestParameters: GetMeasurementsStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeasurementsStatsResponse> {
        const response = await this.getMeasurementsStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMeterInstanceKeysRaw(requestParameters: GetMeterInstanceKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeterInstanceKeysResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getMeterInstanceKeys.');
        }

        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling getMeterInstanceKeys.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        if (requestParameters.productId !== undefined) {
            queryParameters['productId'] = requestParameters.productId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/meter/instance-keys`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeterInstanceKeysResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMeterInstanceKeys(requestParameters: GetMeterInstanceKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeterInstanceKeysResponse> {
        const response = await this.getMeterInstanceKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMetersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMetersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/meters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMetersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMeters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMetersResponse> {
        const response = await this.getMetersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMonthlyClouserReportRaw(requestParameters: GetMonthlyClouserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMonthlyClouserReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/monthly-closure`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMonthlyClouserReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMonthlyClouserReport(requestParameters: GetMonthlyClouserReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMonthlyClouserReportResponse> {
        const response = await this.getMonthlyClouserReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNetSuiteSubsidiariesRaw(requestParameters: GetNetSuiteSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNetSuiteSubsidiariesResponse>> {
        if (requestParameters.erpId === null || requestParameters.erpId === undefined) {
            throw new runtime.RequiredError('erpId','Required parameter requestParameters.erpId was null or undefined when calling getNetSuiteSubsidiaries.');
        }

        const queryParameters: any = {};

        if (requestParameters.erpId !== undefined) {
            queryParameters['erpId'] = requestParameters.erpId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/subsidiaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNetSuiteSubsidiariesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNetSuiteSubsidiaries(requestParameters: GetNetSuiteSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNetSuiteSubsidiariesResponse> {
        const response = await this.getNetSuiteSubsidiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNotificationAlertsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetNotificationAlertsResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notification-alerts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetNotificationAlertsResponseInnerFromJSON));
    }

    /**
     */
    async getNotificationAlerts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetNotificationAlertsResponseInner>> {
        const response = await this.getNotificationAlertsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPaymentOverviewsRaw(requestParameters: GetPaymentOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentOverviewsResponse>> {
        if (requestParameters.startTime === null || requestParameters.startTime === undefined) {
            throw new runtime.RequiredError('startTime','Required parameter requestParameters.startTime was null or undefined when calling getPaymentOverviews.');
        }

        if (requestParameters.endTime === null || requestParameters.endTime === undefined) {
            throw new runtime.RequiredError('endTime','Required parameter requestParameters.endTime was null or undefined when calling getPaymentOverviews.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payments/overviews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentOverviewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentOverviews(requestParameters: GetPaymentOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentOverviewsResponse> {
        const response = await this.getPaymentOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPlanRaw(requestParameters: GetPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlanResponse>> {
        if (requestParameters.planId === null || requestParameters.planId === undefined) {
            throw new runtime.RequiredError('planId','Required parameter requestParameters.planId was null or undefined when calling getPlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlanResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPlan(requestParameters: GetPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlanResponse> {
        const response = await this.getPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPlanOverviewRaw(requestParameters: GetPlanOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlanOverviewResponse>> {
        if (requestParameters.planId === null || requestParameters.planId === undefined) {
            throw new runtime.RequiredError('planId','Required parameter requestParameters.planId was null or undefined when calling getPlanOverview.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan/{planId}/overview`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlanOverviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPlanOverview(requestParameters: GetPlanOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlanOverviewResponse> {
        const response = await this.getPlanOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPlanOverviewsRaw(requestParameters: GetPlanOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlanOverviewsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.planStatuses !== undefined) {
            queryParameters['planStatuses'] = requestParameters.planStatuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plans/overviews`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlanOverviewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPlanOverviews(requestParameters: GetPlanOverviewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlanOverviewsResponse> {
        const response = await this.getPlanOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPotentialChildCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPotentialChildCustomersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/potential-children`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPotentialChildCustomersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPotentialChildCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPotentialChildCustomersResponse> {
        const response = await this.getPotentialChildCustomersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsPageDataRaw(requestParameters: GetProductsPageDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProductsPageDataResponse>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pages/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProductsPageDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProductsPageData(requestParameters: GetProductsPageDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProductsPageDataResponse> {
        const response = await this.getProductsPageDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsUsageReportRaw(requestParameters: GetProductsUsageReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProductsUsageReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/products-usage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProductsUsageReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProductsUsageReport(requestParameters: GetProductsUsageReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProductsUsageReportResponse> {
        const response = await this.getProductsUsageReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReportsResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportsResponseInnerFromJSON));
    }

    /**
     */
    async getReports(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReportsResponseInner>> {
        const response = await this.getReportsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getRevenueByCurrencyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRevenueByCurrencyResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/data-dashboard/revenue-by-currency`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRevenueByCurrencyResponseFromJSON(jsonValue));
    }

    /**
     */
    async getRevenueByCurrency(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRevenueByCurrencyResponse> {
        const response = await this.getRevenueByCurrencyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getRevenueChartDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRevenueChartDataResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/data-dashboard/revenue-chart-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRevenueChartDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getRevenueChartData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRevenueChartDataResponse> {
        const response = await this.getRevenueChartDataRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSandboxUserRaw(requestParameters: GetSandboxUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SandboxUserResponse>> {
        if (requestParameters.environment === null || requestParameters.environment === undefined) {
            throw new runtime.RequiredError('environment','Required parameter requestParameters.environment was null or undefined when calling getSandboxUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.environment !== undefined) {
            queryParameters['environment'] = requestParameters.environment;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/sandbox`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SandboxUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSandboxUser(requestParameters: GetSandboxUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SandboxUserResponse> {
        const response = await this.getSandboxUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSlackUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SlackGetUsersResponseSchema>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/slack/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SlackGetUsersResponseSchemaFromJSON(jsonValue));
    }

    /**
     */
    async getSlackUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SlackGetUsersResponseSchema> {
        const response = await this.getSlackUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUnchargedUsageReportRaw(requestParameters: GetUnchargedUsageReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnchargedUsageReportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.reportId !== undefined) {
            queryParameters['reportId'] = requestParameters.reportId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/uncharged-usage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnchargedUsageReportResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUnchargedUsageReport(requestParameters: GetUnchargedUsageReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnchargedUsageReportResponse> {
        const response = await this.getUnchargedUsageReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsageByMeterRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsageByMeterResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/data-dashboard/usage-by-meter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsageByMeterResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsageByMeter(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsageByMeterResponse> {
        const response = await this.getUsageByMeterRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersResponse> {
        const response = await this.getUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async hubspotAuthCallbackRaw(requestParameters: HubspotAuthCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling hubspotAuthCallback.');
        }

        if (requestParameters.state === null || requestParameters.state === undefined) {
            throw new runtime.RequiredError('state','Required parameter requestParameters.state was null or undefined when calling hubspotAuthCallback.');
        }

        const queryParameters: any = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/integrations/hubspot/auth/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async hubspotAuthCallback(requestParameters: HubspotAuthCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.hubspotAuthCallbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async hubspotAuthConnectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HubspotAuthConnectResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/hubspot/auth/connect`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HubspotAuthConnectResponseFromJSON(jsonValue));
    }

    /**
     */
    async hubspotAuthConnect(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HubspotAuthConnectResponse> {
        const response = await this.hubspotAuthConnectRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async hubspotSyncCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/hubspot/sync-customers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async hubspotSyncCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.hubspotSyncCustomersRaw(initOverrides);
    }

    /**
     */
    async inviteUserRaw(requestParameters: InviteUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.inviteUserRequest === null || requestParameters.inviteUserRequest === undefined) {
            throw new runtime.RequiredError('inviteUserRequest','Required parameter requestParameters.inviteUserRequest was null or undefined when calling inviteUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteUserRequestToJSON(requestParameters.inviteUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async inviteUser(requestParameters: InviteUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.inviteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async loginRaw(requestParameters: LoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        if (requestParameters.loginRequest === null || requestParameters.loginRequest === undefined) {
            throw new runtime.RequiredError('loginRequest','Required parameter requestParameters.loginRequest was null or undefined when calling login.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters.loginRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     */
    async login(requestParameters: LoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.loginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async netSuiteConnectRaw(requestParameters: NetSuiteConnectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.netSuiteConnectRequest === null || requestParameters.netSuiteConnectRequest === undefined) {
            throw new runtime.RequiredError('netSuiteConnectRequest','Required parameter requestParameters.netSuiteConnectRequest was null or undefined when calling netSuiteConnect.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NetSuiteConnectRequestToJSON(requestParameters.netSuiteConnectRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async netSuiteConnect(requestParameters: NetSuiteConnectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.netSuiteConnectRaw(requestParameters, initOverrides);
    }

    /**
     */
    async netSuiteGetCustomerRaw(requestParameters: NetSuiteGetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NetSuiteGetCustomerResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling netSuiteGetCustomer.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/customer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NetSuiteGetCustomerResponseFromJSON(jsonValue));
    }

    /**
     */
    async netSuiteGetCustomer(requestParameters: NetSuiteGetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NetSuiteGetCustomerResponse> {
        const response = await this.netSuiteGetCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async netSuiteGetCustomersRaw(requestParameters: NetSuiteGetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NetSuiteGetCustomersResponse>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NetSuiteGetCustomersResponseFromJSON(jsonValue));
    }

    /**
     */
    async netSuiteGetCustomers(requestParameters: NetSuiteGetCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NetSuiteGetCustomersResponse> {
        const response = await this.netSuiteGetCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async netSuiteGetProductsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NetSuiteGetProductsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NetSuiteGetProductsResponseFromJSON(jsonValue));
    }

    /**
     */
    async netSuiteGetProducts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NetSuiteGetProductsResponse> {
        const response = await this.netSuiteGetProductsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async netSuiteSyncInvoicesRaw(requestParameters: NetSuiteSyncInvoicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NetSuiteSyncInvoicesResponse>> {
        if (requestParameters.netSuiteSyncInvoicesRequest === null || requestParameters.netSuiteSyncInvoicesRequest === undefined) {
            throw new runtime.RequiredError('netSuiteSyncInvoicesRequest','Required parameter requestParameters.netSuiteSyncInvoicesRequest was null or undefined when calling netSuiteSyncInvoices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/sync-invoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NetSuiteSyncInvoicesRequestToJSON(requestParameters.netSuiteSyncInvoicesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NetSuiteSyncInvoicesResponseFromJSON(jsonValue));
    }

    /**
     */
    async netSuiteSyncInvoices(requestParameters: NetSuiteSyncInvoicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NetSuiteSyncInvoicesResponse> {
        const response = await this.netSuiteSyncInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async netSuiteUpdateSalesOrderRaw(requestParameters: NetSuiteUpdateSalesOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.netSuiteUpdateSalesOrderRequest === null || requestParameters.netSuiteUpdateSalesOrderRequest === undefined) {
            throw new runtime.RequiredError('netSuiteUpdateSalesOrderRequest','Required parameter requestParameters.netSuiteUpdateSalesOrderRequest was null or undefined when calling netSuiteUpdateSalesOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/net-suite/update-sales-order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NetSuiteUpdateSalesOrderRequestToJSON(requestParameters.netSuiteUpdateSalesOrderRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async netSuiteUpdateSalesOrder(requestParameters: NetSuiteUpdateSalesOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.netSuiteUpdateSalesOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async rawSignupRaw(requestParameters: RawSignupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignupRawResponse>> {
        if (requestParameters.signupRawRequest === null || requestParameters.signupRawRequest === undefined) {
            throw new runtime.RequiredError('signupRawRequest','Required parameter requestParameters.signupRawRequest was null or undefined when calling rawSignup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/signup/raw`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignupRawRequestToJSON(requestParameters.signupRawRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignupRawResponseFromJSON(jsonValue));
    }

    /**
     */
    async rawSignup(requestParameters: RawSignupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignupRawResponse> {
        const response = await this.rawSignupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async receivePaymentRaw(requestParameters: ReceivePaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.receivePaymentRequest === null || requestParameters.receivePaymentRequest === undefined) {
            throw new runtime.RequiredError('receivePaymentRequest','Required parameter requestParameters.receivePaymentRequest was null or undefined when calling receivePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/receive-payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReceivePaymentRequestToJSON(requestParameters.receivePaymentRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async receivePayment(requestParameters: ReceivePaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.receivePaymentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async refreshTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshTokenResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/refresh-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefreshTokenResponseFromJSON(jsonValue));
    }

    /**
     */
    async refreshToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshTokenResponse> {
        const response = await this.refreshTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async renewContractRaw(requestParameters: RenewContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RenewContractResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling renewContract.');
        }

        if (requestParameters.renewContractRequest === null || requestParameters.renewContractRequest === undefined) {
            throw new runtime.RequiredError('renewContractRequest','Required parameter requestParameters.renewContractRequest was null or undefined when calling renewContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/renew/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenewContractRequestToJSON(requestParameters.renewContractRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenewContractResponseFromJSON(jsonValue));
    }

    /**
     */
    async renewContract(requestParameters: RenewContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RenewContractResponse> {
        const response = await this.renewContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async resetPasswordRaw(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPasswordResponse>> {
        if (requestParameters.resetPasswordRequest === null || requestParameters.resetPasswordRequest === undefined) {
            throw new runtime.RequiredError('resetPasswordRequest','Required parameter requestParameters.resetPasswordRequest was null or undefined when calling resetPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPasswordResponseFromJSON(jsonValue));
    }

    /**
     */
    async resetPassword(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPasswordResponse> {
        const response = await this.resetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reviseContractRaw(requestParameters: ReviseContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReviseContractResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling reviseContract.');
        }

        if (requestParameters.reviseContractRequest === null || requestParameters.reviseContractRequest === undefined) {
            throw new runtime.RequiredError('reviseContractRequest','Required parameter requestParameters.reviseContractRequest was null or undefined when calling reviseContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/revise/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReviseContractRequestToJSON(requestParameters.reviseContractRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReviseContractResponseFromJSON(jsonValue));
    }

    /**
     */
    async reviseContract(requestParameters: ReviseContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReviseContractResponse> {
        const response = await this.reviseContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesforceConnectRaw(requestParameters: SalesforceConnectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.salesforceConnectRequest === null || requestParameters.salesforceConnectRequest === undefined) {
            throw new runtime.RequiredError('salesforceConnectRequest','Required parameter requestParameters.salesforceConnectRequest was null or undefined when calling salesforceConnect.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/salesforce/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SalesforceConnectRequestToJSON(requestParameters.salesforceConnectRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesforceConnect(requestParameters: SalesforceConnectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesforceConnectRaw(requestParameters, initOverrides);
    }

    /**
     */
    async salesforceImportCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SalesforceImportCustomersResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/salesforce/import-customers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SalesforceImportCustomersResponseInnerFromJSON));
    }

    /**
     */
    async salesforceImportCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SalesforceImportCustomersResponseInner>> {
        const response = await this.salesforceImportCustomersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async sendSlackInvoiceApprovalMessageRaw(requestParameters: SendSlackInvoiceApprovalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SlackSendInvoiceApprovalMessageResponseSchema>> {
        if (requestParameters.slackSendInvoiceApprovalMessageRequestSchema === null || requestParameters.slackSendInvoiceApprovalMessageRequestSchema === undefined) {
            throw new runtime.RequiredError('slackSendInvoiceApprovalMessageRequestSchema','Required parameter requestParameters.slackSendInvoiceApprovalMessageRequestSchema was null or undefined when calling sendSlackInvoiceApprovalMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/slack/invoice-approval`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SlackSendInvoiceApprovalMessageRequestSchemaToJSON(requestParameters.slackSendInvoiceApprovalMessageRequestSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SlackSendInvoiceApprovalMessageResponseSchemaFromJSON(jsonValue));
    }

    /**
     */
    async sendSlackInvoiceApprovalMessage(requestParameters: SendSlackInvoiceApprovalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SlackSendInvoiceApprovalMessageResponseSchema> {
        const response = await this.sendSlackInvoiceApprovalMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async shareInvoicesRaw(requestParameters: ShareInvoicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.shareInvoicesRequest === null || requestParameters.shareInvoicesRequest === undefined) {
            throw new runtime.RequiredError('shareInvoicesRequest','Required parameter requestParameters.shareInvoicesRequest was null or undefined when calling shareInvoices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/share`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.shareInvoicesRequest.map(ShareInvoicesRequestToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shareInvoices(requestParameters: ShareInvoicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shareInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async signupRaw(requestParameters: SignupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignupResponse>> {
        if (requestParameters.signupRequest === null || requestParameters.signupRequest === undefined) {
            throw new runtime.RequiredError('signupRequest','Required parameter requestParameters.signupRequest was null or undefined when calling signup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignupRequestToJSON(requestParameters.signupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignupResponseFromJSON(jsonValue));
    }

    /**
     */
    async signup(requestParameters: SignupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignupResponse> {
        const response = await this.signupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async slackCallbackRaw(requestParameters: SlackCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling slackCallback.');
        }

        if (requestParameters.state === null || requestParameters.state === undefined) {
            throw new runtime.RequiredError('state','Required parameter requestParameters.state was null or undefined when calling slackCallback.');
        }

        const queryParameters: any = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/integrations/slack/auth/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async slackCallback(requestParameters: SlackCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.slackCallbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async slackConnectRaw(requestParameters: SlackConnectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SlackAuthConnectRedirectResponseSchema>> {
        if (requestParameters.redirectUrl === null || requestParameters.redirectUrl === undefined) {
            throw new runtime.RequiredError('redirectUrl','Required parameter requestParameters.redirectUrl was null or undefined when calling slackConnect.');
        }

        const queryParameters: any = {};

        if (requestParameters.redirectUrl !== undefined) {
            queryParameters['redirectUrl'] = requestParameters.redirectUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/slack/auth/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SlackAuthConnectRedirectResponseSchemaFromJSON(jsonValue));
    }

    /**
     */
    async slackConnect(requestParameters: SlackConnectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SlackAuthConnectRedirectResponseSchema> {
        const response = await this.slackConnectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async softUpdatePlanRaw(requestParameters: SoftUpdatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoftUpdatePlanResponse>> {
        if (requestParameters.planId === null || requestParameters.planId === undefined) {
            throw new runtime.RequiredError('planId','Required parameter requestParameters.planId was null or undefined when calling softUpdatePlan.');
        }

        if (requestParameters.softUpdatePlanRequest === null || requestParameters.softUpdatePlanRequest === undefined) {
            throw new runtime.RequiredError('softUpdatePlanRequest','Required parameter requestParameters.softUpdatePlanRequest was null or undefined when calling softUpdatePlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan/soft/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SoftUpdatePlanRequestToJSON(requestParameters.softUpdatePlanRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SoftUpdatePlanResponseFromJSON(jsonValue));
    }

    /**
     */
    async softUpdatePlan(requestParameters: SoftUpdatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoftUpdatePlanResponse> {
        const response = await this.softUpdatePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async stripeConnectRaw(requestParameters: StripeConnectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.stripeConnectRequest === null || requestParameters.stripeConnectRequest === undefined) {
            throw new runtime.RequiredError('stripeConnectRequest','Required parameter requestParameters.stripeConnectRequest was null or undefined when calling stripeConnect.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/stripe/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StripeConnectRequestToJSON(requestParameters.stripeConnectRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async stripeConnect(requestParameters: StripeConnectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.stripeConnectRaw(requestParameters, initOverrides);
    }

    /**
     */
    async stripeCreateInvoiceRaw(requestParameters: StripeCreateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StripeCreateInvoiceResponseInner>>> {
        if (requestParameters.stripeCreateInvoiceRequest === null || requestParameters.stripeCreateInvoiceRequest === undefined) {
            throw new runtime.RequiredError('stripeCreateInvoiceRequest','Required parameter requestParameters.stripeCreateInvoiceRequest was null or undefined when calling stripeCreateInvoice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/stripe/invoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StripeCreateInvoiceRequestToJSON(requestParameters.stripeCreateInvoiceRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StripeCreateInvoiceResponseInnerFromJSON));
    }

    /**
     */
    async stripeCreateInvoice(requestParameters: StripeCreateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StripeCreateInvoiceResponseInner>> {
        const response = await this.stripeCreateInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async stripeEventRaw(requestParameters: StripeEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.stripeEventAccountId === null || requestParameters.stripeEventAccountId === undefined) {
            throw new runtime.RequiredError('stripeEventAccountId','Required parameter requestParameters.stripeEventAccountId was null or undefined when calling stripeEvent.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling stripeEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.stripeEventAccountId !== undefined) {
            queryParameters['stripeEventAccountId'] = requestParameters.stripeEventAccountId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/integrations/stripe/event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async stripeEvent(requestParameters: StripeEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.stripeEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async stripeGetCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeGetCustomersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/stripe/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeGetCustomersResponseFromJSON(jsonValue));
    }

    /**
     */
    async stripeGetCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeGetCustomersResponse> {
        const response = await this.stripeGetCustomersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async terminateContractRaw(requestParameters: TerminateContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminateContractResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling terminateContract.');
        }

        if (requestParameters.terminateContractRequest === null || requestParameters.terminateContractRequest === undefined) {
            throw new runtime.RequiredError('terminateContractRequest','Required parameter requestParameters.terminateContractRequest was null or undefined when calling terminateContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/terminate/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TerminateContractRequestToJSON(requestParameters.terminateContractRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminateContractResponseFromJSON(jsonValue));
    }

    /**
     */
    async terminateContract(requestParameters: TerminateContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminateContractResponse> {
        const response = await this.terminateContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async triggerLineItemsCalculatorRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/line-items/trigger-calculator`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async triggerLineItemsCalculator(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.triggerLineItemsCalculatorRaw(initOverrides);
    }

    /**
     */
    async triggerReportJobRaw(requestParameters: TriggerReportJobOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerReportJobResponse>> {
        if (requestParameters.triggerReportJobRequest === null || requestParameters.triggerReportJobRequest === undefined) {
            throw new runtime.RequiredError('triggerReportJobRequest','Required parameter requestParameters.triggerReportJobRequest was null or undefined when calling triggerReportJob.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/trigger`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriggerReportJobRequestToJSON(requestParameters.triggerReportJobRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerReportJobResponseFromJSON(jsonValue));
    }

    /**
     */
    async triggerReportJob(requestParameters: TriggerReportJobOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerReportJobResponse> {
        const response = await this.triggerReportJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAccountResponse>> {
        if (requestParameters.updateAccountRequest === null || requestParameters.updateAccountRequest === undefined) {
            throw new runtime.RequiredError('updateAccountRequest','Required parameter requestParameters.updateAccountRequest was null or undefined when calling updateAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountRequestToJSON(requestParameters.updateAccountRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAccountResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAccountResponse> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateBillingCycleRaw(requestParameters: UpdateBillingCycleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingCycleResponse>> {
        if (requestParameters.billingCycleId === null || requestParameters.billingCycleId === undefined) {
            throw new runtime.RequiredError('billingCycleId','Required parameter requestParameters.billingCycleId was null or undefined when calling updateBillingCycle.');
        }

        if (requestParameters.updateBillingCycleRequest === null || requestParameters.updateBillingCycleRequest === undefined) {
            throw new runtime.RequiredError('updateBillingCycleRequest','Required parameter requestParameters.updateBillingCycleRequest was null or undefined when calling updateBillingCycle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-cycle/{billingCycleId}`.replace(`{${"billingCycleId"}}`, encodeURIComponent(String(requestParameters.billingCycleId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingCycleRequestToJSON(requestParameters.updateBillingCycleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingCycleResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateBillingCycle(requestParameters: UpdateBillingCycleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingCycleResponse> {
        const response = await this.updateBillingCycleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateContractRaw(requestParameters: UpdateContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateContractResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling updateContract.');
        }

        if (requestParameters.updateContractRequest === null || requestParameters.updateContractRequest === undefined) {
            throw new runtime.RequiredError('updateContractRequest','Required parameter requestParameters.updateContractRequest was null or undefined when calling updateContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContractRequestToJSON(requestParameters.updateContractRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateContractResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateContract(requestParameters: UpdateContractOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateContractResponse> {
        const response = await this.updateContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateContractStatusRaw(requestParameters: UpdateContractStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateContractStatusResponse>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling updateContractStatus.');
        }

        if (requestParameters.updateContractStatusRequest === null || requestParameters.updateContractStatusRequest === undefined) {
            throw new runtime.RequiredError('updateContractStatusRequest','Required parameter requestParameters.updateContractStatusRequest was null or undefined when calling updateContractStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/status/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContractStatusRequestToJSON(requestParameters.updateContractStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateContractStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateContractStatus(requestParameters: UpdateContractStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateContractStatusResponse> {
        const response = await this.updateContractStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCustomerRaw(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCustomerResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling updateCustomer.');
        }

        if (requestParameters.updateCustomerRequest === null || requestParameters.updateCustomerRequest === undefined) {
            throw new runtime.RequiredError('updateCustomerRequest','Required parameter requestParameters.updateCustomerRequest was null or undefined when calling updateCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCustomerRequestToJSON(requestParameters.updateCustomerRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCustomerResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCustomer(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCustomerResponse> {
        const response = await this.updateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCustomerChildrenRaw(requestParameters: UpdateCustomerChildrenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCustomerChildrenResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling updateCustomerChildren.');
        }

        if (requestParameters.updateCustomerChildrenRequest === null || requestParameters.updateCustomerChildrenRequest === undefined) {
            throw new runtime.RequiredError('updateCustomerChildrenRequest','Required parameter requestParameters.updateCustomerChildrenRequest was null or undefined when calling updateCustomerChildren.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customer/{customerId}/children`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCustomerChildrenRequestToJSON(requestParameters.updateCustomerChildrenRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCustomerChildrenResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCustomerChildren(requestParameters: UpdateCustomerChildrenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCustomerChildrenResponse> {
        const response = await this.updateCustomerChildrenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateIntegrationConfigurationRaw(requestParameters: UpdateIntegrationConfigurationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateIntegrationConfigurationResponse>> {
        if (requestParameters.updateIntegrationConfigurationRequest === null || requestParameters.updateIntegrationConfigurationRequest === undefined) {
            throw new runtime.RequiredError('updateIntegrationConfigurationRequest','Required parameter requestParameters.updateIntegrationConfigurationRequest was null or undefined when calling updateIntegrationConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/configuration`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIntegrationConfigurationRequestToJSON(requestParameters.updateIntegrationConfigurationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateIntegrationConfigurationResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateIntegrationConfiguration(requestParameters: UpdateIntegrationConfigurationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateIntegrationConfigurationResponse> {
        const response = await this.updateIntegrationConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateInvoiceAdditionalDetailsRaw(requestParameters: UpdateInvoiceAdditionalDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateInvoiceAdditionalDetailsResponse>> {
        if (requestParameters.updateInvoiceAdditionalDetailsRequest === null || requestParameters.updateInvoiceAdditionalDetailsRequest === undefined) {
            throw new runtime.RequiredError('updateInvoiceAdditionalDetailsRequest','Required parameter requestParameters.updateInvoiceAdditionalDetailsRequest was null or undefined when calling updateInvoiceAdditionalDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoice/additional-details`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInvoiceAdditionalDetailsRequestToJSON(requestParameters.updateInvoiceAdditionalDetailsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateInvoiceAdditionalDetailsResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateInvoiceAdditionalDetails(requestParameters: UpdateInvoiceAdditionalDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateInvoiceAdditionalDetailsResponse> {
        const response = await this.updateInvoiceAdditionalDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateInvoicesBillingStatusesRaw(requestParameters: UpdateInvoicesBillingStatusesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateInvoicesBillingStatusesResponse>> {
        if (requestParameters.updateInvoicesBillingStatusesRequest === null || requestParameters.updateInvoicesBillingStatusesRequest === undefined) {
            throw new runtime.RequiredError('updateInvoicesBillingStatusesRequest','Required parameter requestParameters.updateInvoicesBillingStatusesRequest was null or undefined when calling updateInvoicesBillingStatuses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/billing-statuses`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInvoicesBillingStatusesRequestToJSON(requestParameters.updateInvoicesBillingStatusesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateInvoicesBillingStatusesResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateInvoicesBillingStatuses(requestParameters: UpdateInvoicesBillingStatusesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateInvoicesBillingStatusesResponse> {
        const response = await this.updateInvoicesBillingStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateInvoicesReviewStatusesRaw(requestParameters: UpdateInvoicesReviewStatusesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateInvoicesReviewStatusesResponse>> {
        if (requestParameters.updateInvoicesReviewStatusesRequest === null || requestParameters.updateInvoicesReviewStatusesRequest === undefined) {
            throw new runtime.RequiredError('updateInvoicesReviewStatusesRequest','Required parameter requestParameters.updateInvoicesReviewStatusesRequest was null or undefined when calling updateInvoicesReviewStatuses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/review-statuses`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInvoicesReviewStatusesRequestToJSON(requestParameters.updateInvoicesReviewStatusesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateInvoicesReviewStatusesResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateInvoicesReviewStatuses(requestParameters: UpdateInvoicesReviewStatusesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateInvoicesReviewStatusesResponse> {
        const response = await this.updateInvoicesReviewStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLineItemRaw(requestParameters: UpdateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLineItemResponse>> {
        if (requestParameters.lineItemId === null || requestParameters.lineItemId === undefined) {
            throw new runtime.RequiredError('lineItemId','Required parameter requestParameters.lineItemId was null or undefined when calling updateLineItem.');
        }

        if (requestParameters.updateLineItemRequest === null || requestParameters.updateLineItemRequest === undefined) {
            throw new runtime.RequiredError('updateLineItemRequest','Required parameter requestParameters.updateLineItemRequest was null or undefined when calling updateLineItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/line-item/{lineItemId}`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLineItemRequestToJSON(requestParameters.updateLineItemRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLineItemResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateLineItem(requestParameters: UpdateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLineItemResponse> {
        const response = await this.updateLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMeterRaw(requestParameters: UpdateMeterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateMeterResponse>> {
        if (requestParameters.meterId === null || requestParameters.meterId === undefined) {
            throw new runtime.RequiredError('meterId','Required parameter requestParameters.meterId was null or undefined when calling updateMeter.');
        }

        if (requestParameters.updateMeterRequest === null || requestParameters.updateMeterRequest === undefined) {
            throw new runtime.RequiredError('updateMeterRequest','Required parameter requestParameters.updateMeterRequest was null or undefined when calling updateMeter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/meter/{meterId}`.replace(`{${"meterId"}}`, encodeURIComponent(String(requestParameters.meterId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMeterRequestToJSON(requestParameters.updateMeterRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateMeterResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateMeter(requestParameters: UpdateMeterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateMeterResponse> {
        const response = await this.updateMeterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateNotificationAlertStatusRaw(requestParameters: UpdateNotificationAlertStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateNotificationAlertStatusResponse>> {
        if (requestParameters.notificationAlertId === null || requestParameters.notificationAlertId === undefined) {
            throw new runtime.RequiredError('notificationAlertId','Required parameter requestParameters.notificationAlertId was null or undefined when calling updateNotificationAlertStatus.');
        }

        if (requestParameters.updateNotificationAlertStatusRequest === null || requestParameters.updateNotificationAlertStatusRequest === undefined) {
            throw new runtime.RequiredError('updateNotificationAlertStatusRequest','Required parameter requestParameters.updateNotificationAlertStatusRequest was null or undefined when calling updateNotificationAlertStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notification-alert/{notificationAlertId}/status`.replace(`{${"notificationAlertId"}}`, encodeURIComponent(String(requestParameters.notificationAlertId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNotificationAlertStatusRequestToJSON(requestParameters.updateNotificationAlertStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateNotificationAlertStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateNotificationAlertStatus(requestParameters: UpdateNotificationAlertStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateNotificationAlertStatusResponse> {
        const response = await this.updateNotificationAlertStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updatePlanRaw(requestParameters: UpdatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePlanResponse>> {
        if (requestParameters.planId === null || requestParameters.planId === undefined) {
            throw new runtime.RequiredError('planId','Required parameter requestParameters.planId was null or undefined when calling updatePlan.');
        }

        if (requestParameters.updatePlanRequest === null || requestParameters.updatePlanRequest === undefined) {
            throw new runtime.RequiredError('updatePlanRequest','Required parameter requestParameters.updatePlanRequest was null or undefined when calling updatePlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlanRequestToJSON(requestParameters.updatePlanRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePlanResponseFromJSON(jsonValue));
    }

    /**
     */
    async updatePlan(requestParameters: UpdatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePlanResponse> {
        const response = await this.updatePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateRevisionedLineItemRaw(requestParameters: UpdateRevisionedLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateRevisionedLineItemResponse>> {
        if (requestParameters.revisionedLineItemId === null || requestParameters.revisionedLineItemId === undefined) {
            throw new runtime.RequiredError('revisionedLineItemId','Required parameter requestParameters.revisionedLineItemId was null or undefined when calling updateRevisionedLineItem.');
        }

        if (requestParameters.updateRevisionedLineItemRequest === null || requestParameters.updateRevisionedLineItemRequest === undefined) {
            throw new runtime.RequiredError('updateRevisionedLineItemRequest','Required parameter requestParameters.updateRevisionedLineItemRequest was null or undefined when calling updateRevisionedLineItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/revisioned-line-item/{revisionedLineItemId}`.replace(`{${"revisionedLineItemId"}}`, encodeURIComponent(String(requestParameters.revisionedLineItemId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRevisionedLineItemRequestToJSON(requestParameters.updateRevisionedLineItemRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateRevisionedLineItemResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateRevisionedLineItem(requestParameters: UpdateRevisionedLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateRevisionedLineItemResponse> {
        const response = await this.updateRevisionedLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadMeasurementsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadMeasurementsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/measurements/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadMeasurementsResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadMeasurements(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadMeasurementsResponse> {
        const response = await this.uploadMeasurementsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async validateMeasurementDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateMeasurementDataResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuthorizer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/measurements/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateMeasurementDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async validateMeasurementData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateMeasurementDataResponse> {
        const response = await this.validateMeasurementDataRaw(initOverrides);
        return await response.value();
    }

}
